<template>
  <div>
    <div
      class="product-window group-con"
      :class="attr.cartAttr === true ? 'on' : ''"
      :style="'padding-bottom:' + (isShowBtn ? '0' : '')"
    >
      <div class="textpic acea-row row-between-wrapper">
        <div class="pictrue">
          <img :src="attr.productSelect.image" class="image" />
        </div>
        <div class="text">
          <div class="line1">{{ attr.productSelect.store_name }}</div>
          <div class="money font-color-red">
            ￥
            <span class="num">{{ attr.productSelect.price }}</span>
            <span class="stock" v-if="isShow">库存: {{ attr.productSelect.stock }}</span>
            <span class="stock" v-else>
              限量:
              {{
              attr.productSelect.quota_show
              ? attr.productSelect.quota_show
              : 0
              }}
            </span>
          </div>
        </div>
        <div class="iconfont icon-guanbi" @click="closeAttr"></div>
      </div>
      <div class="productWinList">
        <div class="item" v-for="(item, indexw) in attr.productAttr" :key="indexw">
          <div class="title">{{ item.attr_name }}</div>
          <div class="listn acea-row row-middle">
            <div
              class="itemn"
              :class="item.index === itemn.attr ? 'on' : ''"
              v-for="(itemn, indexn) in item.attr_value"
              @click="tapAttr(indexw, itemn.attr)"
              :key="indexn"
            >{{ itemn.attr }}</div>
          </div>
        </div>
      </div>
      <div class="cart">
        <div class="title">数量</div>
        <!-- @click="CartNumDes"  去掉，不让用户执行-- -->
        <div class="carnum acea-row row-left">
          <div
            class="item reduce"
            :class="attr.productSelect.cart_num <= 1 ? 'on' : ''"
            
          >-</div>
          <!-- 新增了readonly 不让用户输入 -->
          <div class="item num">
            <input type="number" readonly v-model="attr.productSelect.cart_num" class="ipt_num" />
          </div>
          <!-- 新增了on，为了样式， @click="CartNumAdd" 去掉，不让用户执行++  -->
          <div
            class="item plus on"
            :class="
              attr.productSelect.cart_num >= attr.productSelect.stock
                ? 'on'
                : ''
            "
          >+</div>
        </div>
      </div>
      <div class="wrapper" v-if="isShowBtn">
        <div
          class="teamBnt bg-color-red"
          @click="openAlone"
          v-if="
            attr.productSelect.quota > 0 && attr.productSelect.product_stock > 0
          "
        >立即参团</div>
        <div class="teamBnt bg-color-hui" v-else>已售罄</div>
      </div>
    </div>
    <div class="mask" @touchmove.prevent :hidden="attr.cartAttr === false" @click="closeAttr"></div>
    <BindPhone v-on:setVisibleStatus="setVisibleStatus" :visibleStatus="visibleStatus"></BindPhone>
  </div>
</template>
<script>
import BindPhone from "@components/BindPhone"; //绑定手机号
import { getUserInfo } from "@api/user";

export default {
  name: "ProductWindow",
  components: {
    BindPhone //绑定手机号组件
  },
  props: {
    attr: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {
      visibleStatus: false //弹窗隐藏false/显示true
    };
  },
  computed: {
    isShow() {
      return this.$route.path.indexOf("detail") === 1;
    },
    isShowBtn() {
      return this.$route.path.indexOf("group_rule") != -1;
    }
  },
  mounted: function() {},
  methods: {
    openAlone() {
      var that = this;
      getUserInfo().then(res => {
        //判断是否绑定phone
        if (
          res.data.phone === "" ||
          res.data.phone === undefined ||
          res.data.phone === null
        ) {
          //未绑定手机号，进行弹窗绑定
          that.visibleStatus = true;
        } else {
          //已绑定手机号，跳转链接
          that.$emit("changeFun", { action: "goPay", value: false });
        }
      });
      // this.$emit("changeFun", { action: "goPay", value: false });
    },
    setVisibleStatus: function() {
      //点击除弹窗之外 空余处弹窗消失
      console.log("弹窗之外");
      var sTop = document.body || document.documentElement;
      sTop.scrollTop = 0;
      this.visibleStatus = !this.visibleStatus;
    },
    closeAttr: function() {
      this.$emit("changeFun", { action: "changeattr", value: false });
    },
    CartNumDes: function() {
      this.$emit("changeFun", { action: "ChangeCartNum", value: false });
    },
    CartNumAdd: function() {
      this.$emit("changeFun", { action: "ChangeCartNum", value: 1 });
    },
    tapAttr: function(indexw, indexn) {
      let that = this;
      that.attr.productAttr[indexw].index = indexn;
      let value = that
        .getCheckedValue()
        .sort()
        .join(",");
      that.$emit("changeFun", { action: "ChangeAttr", value: value });
    },
    //获取被选中属性；
    getCheckedValue: function() {
      let productAttr = this.attr.productAttr;
      let value = [];
      for (let i = 0; i < productAttr.length; i++) {
        for (let j = 0; j < productAttr[i].attr_value.length; j++) {
          if (productAttr[i].index === productAttr[i].attr_value[j].attr) {
            value.push(productAttr[i].attr_value[j].attr);
          }
        }
      }
      return value;
    }
  }
};
</script>
<style scoped>
.joinCart {
  width: 80%;
  height: 0.76rem;
  line-height: 0.76rem;
  text-align: center;
}
.ipt_num {
  width: 100%;
  display: block;
  line-height: 0.54rem;
  text-align: center;
}
.product-window .cart .carnum .num{
  border-color: #e3e3e3;
}
</style>
